function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.8294 15.11C16.4804 15.11 16.1674 14.865 16.0954 14.51C16.0124 14.104 16.2744 13.708 16.6804 13.625C19.4114 13.069 22.3064 9.707 22.5624 4.5H19.2504C18.8364 4.5 18.5004 4.164 18.5004 3.75C18.5004 3.336 18.8364 3 19.2504 3H23.3304C23.7444 3 24.0804 3.336 24.0804 3.75C24.0804 10.249 20.5084 14.376 16.9804 15.095C16.9294 15.105 16.8794 15.11 16.8294 15.11Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.161 15.09C7.107 15.09 7.052 15.084 6.996 15.072C3.52 14.292 0 10.153 0 3.75C0 3.336 0.336 3 0.75 3H4.75C5.164 3 5.5 3.336 5.5 3.75C5.5 4.164 5.164 4.5 4.75 4.5H1.519C1.774 9.634 4.63 13.004 7.325 13.608C7.729 13.699 7.983 14.1 7.893 14.504C7.814 14.853 7.504 15.09 7.161 15.09Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.25 16.1101C12.836 16.1101 12.5 16.4461 12.5 16.8601H11.5C11.5 16.4461 11.164 16.1101 10.75 16.1101C10.336 16.1101 10 16.4461 10 16.8601V20.5001C10 20.9141 10.336 21.2501 10.75 21.2501H13.25C13.664 21.2501 14 20.9141 14 20.5001V16.8601C14 16.4461 13.664 16.1101 13.25 16.1101Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.25 20H9.75C8.233 20 7 21.233 7 22.75V23.25C7 23.664 7.336 24 7.75 24H16.25C16.664 24 17 23.664 17 23.25V22.75C17 21.233 15.767 20 14.25 20Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.25 0H5.75C4.785 0 4 0.785 4 1.75V9.005C4.043 15.461 11.439 18.1 11.754 18.209C11.834 18.237 11.917 18.251 12 18.251C12.083 18.251 12.166 18.237 12.245 18.21C12.561 18.1 20 15.46 20 9V1.75C20 0.785 19.215 0 18.25 0Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.66722c15.svg";
export { ForwardRef as ReactComponent };